module.exports = __webpack_public_path__ + "static/media/mobile-development.4d27cec8.svg";